<template>
	<div v-if="items.length" class="csv-exports-panel" data-test="csv-exports-panel">
		<v-card v-for="item in items" :key="item.id" class="csv-export-card mb-2 elevation-6" dark width="320" :data-test="'csv-export-' + item.status">
			<div class="d-flex align-center pa-3 pb-2">
				<v-icon small class="mr-3">mdi-file-delimited-outline</v-icon>
				<div class="flex-grow-1" style="min-width: 0">
					<div class="fw500 fs13i text-truncate">Export {{ item.title }}</div>
					<div class="fs12i grey--text text--lighten-1">{{ statusText(item) }}</div>
				</div>
				<v-btn v-if="item.status === 'done'" small text color="primary" class="ml-2" data-test="csv-export-download" @click="download(item)">Scarica</v-btn>
				<v-btn v-if="!running(item)" icon small class="ml-1" @click="dismiss(item)">
					<v-icon small>mdi-close</v-icon>
				</v-btn>
			</div>
			<v-progress-linear v-if="running(item)" :value="item.total ? item.done / item.total * 100 : 0" :indeterminate="item.status === 'queued'" color="primary" height="3"></v-progress-linear>
		</v-card>
	</div>
</template>

<script>
	import { csvExports, dismissCsvExport, loadCsvExports, saveCsvExports } from '@/services/csvExports'

	const POLL_MS = 2000

	export default {
		name: 'csv-exports-panel',
		data() {
			return {
				timer: null,
			}
		},
		computed: {
			// export del tenant e dell'utente collegati
			scope() {
				const userId = this.$store.getters.getUserId
				return userId ? localStorage.getItem('fqdn') + '_' + userId : null
			},
			items() {
				return csvExports.items
			},
			pending() {
				return this.items.filter(item => this.running(item))
			},
		},
		watch: {
			scope: {
				immediate: true,
				handler(scope) {
					loadCsvExports(scope)
				},
			},
			pending: {
				immediate: true,
				handler(pending) {
					if (pending.length && !this.timer) {
						this.timer = setInterval(this.poll, POLL_MS)
					} else if (!pending.length && this.timer) {
						clearInterval(this.timer)
						this.timer = null
					}
				},
			},
		},
		beforeDestroy() {
			clearInterval(this.timer)
		},
		methods: {
			running(item) {
				return item.status === 'queued' || item.status === 'running'
			},
			statusText(item) {
				if (item.status === 'queued') return 'In coda…'
				if (item.status === 'running') return `${item.done.toLocaleString('it-IT')} / ${item.total.toLocaleString('it-IT')}`
				if (item.status === 'done') return 'Pronto, anche negli Archivi'
				return 'Non riuscito'
			},
			poll() {
				if (!this.$store.getters.token) return
				this.pending.forEach(item => {
					this.axios.get('csv-exports/' + item.id).then(response => {
						// missing: scaduto o di un altro utente. Gli errori di rete si riprovano al giro dopo
						Object.assign(item, response.data.status === 'missing' ? { status: 'failed' } : response.data)
						saveCsvExports()
					}, () => {})
				})
			},
			download(item) {
				this.$eventBusUtility.openFile(this.$store, '/csv-exports/' + item.id + '/file', item.file_name)
			},
			dismiss(item) {
				dismissCsvExport(item.id)
			},
		},
	}
</script>

<style scoped>
/* sopra il pulsante azioni: la sua lista si apre verso sinistra sulla riga in basso */
.csv-exports-panel {
	position: fixed;
	right: 16px;
	bottom: 88px;
	z-index: 11;
	max-width: calc(100vw - 32px);
}

.csv-export-card {
	background-color: #323232 !important;
	border-radius: 8px !important;
	overflow: hidden;
}
</style>
